import { IJsonSerializable } from '../util/interfaces'
import { OpChangeState } from '../common/enums'
import { DeviceFunctionType } from '../../helpers/common-helper'

export class OpConfigurationProfileFunction implements IJsonSerializable {

    //#region Properties

    public idConfigurationProfile: number
    public indexNbr: number
    public functionType: DeviceFunctionType

    //#endregion

    
    //#region Custom Properties

    public opState: OpChangeState
    public type: string

    //#endregion


    //#region Ctor
    
    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //#endregion


    //#region IJsonSerializable Implementation

    public toJSON(compressed: boolean = false): any {
        return {
            IdConfigurationProfile: this.idConfigurationProfile,
            FunctionType: this.functionType,
            IndexNbr: this.indexNbr,
            OpState: this.opState,
            __type: this.type,
        }
    }

    public fromJSON(opObj: any, compressed: boolean = false): void {
        this.idConfigurationProfile = opObj.IdConfigurationProfile
        this.functionType = opObj.FunctionType
        this.indexNbr = opObj.IndexNbr
        this.opState = opObj.OpState
        this.type = opObj.__type
    }

    //#endregion
}